var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChastity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.45 21.785c-50.2.096-98.177 39.404-99.67 103.264h-.003C58.094 239.693 207.683 268.72 254.8 383.163c42.852-114.436 187.95-150.36 190.53-258.115 2.293-95.77-96.364-127.004-160.037-80.736l39.533 114.553-44.945-11.256 26.802 109.964-89.325-149.008 52.3 5.848-50.92-73.105c-17.913-13.358-38.275-19.563-58.288-19.525zM105.3 331.24c-51.466 16.674-84.68 41.936-84.68 69.955 0 50.166 104.813 91.108 234.19 91.106 129.374 0 234.19-40.94 234.19-91.105 0-28.02-33.215-53.28-84.682-69.955 27.147 12.916 43.8 29.23 43.8 47.18 0 41.414-86.502 74.836-193.31 74.836-106.805 0-193.31-33.422-193.31-74.836 0-17.95 16.656-34.264 43.803-47.18zm68.915 13.828c-28.252 9.053-46.72 22.11-46.72 37.418 0 27.24 57.065 49.62 127.314 49.62 70.247 0 127.315-22.38 127.315-49.62 0-15.31-18.47-28.365-46.72-37.418 14.94 7.037 24.527 15.398 24.527 25.217 0 22.488-47.13 40.672-105.123 40.672-57.994 0-105.124-18.186-105.124-40.672 0-9.82 9.59-18.18 24.53-25.217z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChastity);
export default __webpack_public_path__ + "static/media/chastity.9a7b90e263240c75708f5ef9db712c4a.svg";
export { ForwardRef as ReactComponent };